export function objToQueryString(obj: any) {
  let queryString = '';

  if (!obj) {
    return queryString;
  }

  Object.keys(obj).forEach((key: string) => {
    let value = obj[key];
    if (value) {
      queryString += `${key}=${encodeURIComponent(value)}&`;
    }
  });

  return queryString;
}

export function toJson(obj: any) {

    try {

       return obj.json();

    } catch (e) {

        console.log('cannot deserialize the current json object');

        return null;

    }
}

export function strToUrl(str: string) {
    return str.replace(/_ /g, '-').toLowerCase();
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/utils.ts